<template>
  <div>
    <div class="content-block">
      <h3 class="content-block-title">
        Bekijk deze school op
      </h3>
      <a
        v-if="school.scholenopdekaart"
        class="link"
        :href="school.scholenopdekaart"
        target="_blank"
      >
        Scholen op de kaart
      </a>
      <a
        v-if="school.schoolwijzerlink"
        class="link"
        :href="school.schoolwijzerlink"
        target="_blank"
      >
        Schoolwijzer Amsterdam
      </a>
      <a
        v-if="school.inspectielink"
        class="link"
        :href="school.inspectielink"
        target="_blank"
      >
        Website schoolinspectie
      </a>
      <a
        v-if="school.vokeuzegids_link"
        class="link"
        :href="school.vokeuzegids_link"
        target="_blank"
      >
        VOschoolkeuze020
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
};

function isset(value) {
  return !!value;
}
</script>
<style lang="scss" scoped>
.link {
  display: block;
  margin-bottom: 4px;

  &:hover {
    color: red;
  }
}
</style>
